var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { FullVaultList } from "../constants/constants";
export var ERC20TokenList = __spreadArray([
    "weth",
    "usdc",
    "wbtc",
    "yvusdc",
    "rbn"
], FullVaultList);
export var getERC20TokenDecimals = function (asset) {
    switch (asset) {
        case "usdc":
        case "yvusdc":
            return 6;
        case "wbtc":
            return 8;
        default:
            return 18;
    }
};
export var getERC20TokenDisplay = function (asset) {
    switch (asset) {
        case "yvusdc":
            return "yvUSDC";
        default:
            return asset.toUpperCase();
    }
};
//# sourceMappingURL=eth.js.map